/* eslint-disable react-hooks/exhaustive-deps */

import { Box, Button, Grid, Link, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { signOut } from "aws-amplify/auth";

import IconRejected from "@components/Images/IconRejected";
import CustomRightImage from "@components/CustomRightImagev2";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";

interface SinOfertaProps {
  type: "rechazado" | "sin_oferta";
}

const SinOferta: React.FC<SinOfertaProps> = ({ type }) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const personal_data = useSelector((state: RootState) => state.register.personal_data);

  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));
  const handleClick = async () => {
    await signOut();
    navigate("/login");
  };

  useEffect(() => {
    document.body.style.backgroundColor =
      theme?.palette?.screenBackground?.backgroundColor || theme?.palette?.primary?.dark;
    return () => {
      document.body.style.backgroundColor = "";
    };
  }, []);

  return (
    <Grid container height="100%">
      <Grid item xs={12} md={8} mt={4}>
        <Box>
          <Typography
            variant={isMobileOrTablet ? "h4" : "h3"}
            color={theme?.palette?.screenBackground?.textColor || theme?.palette?.primary.main}
            fontWeight={500}
            align="center"
          >
            ¡Hola!
            <br />
            {personal_data.name} {personal_data.first_lastname} {personal_data.second_lastname}
          </Typography>

          {type === "sin_oferta" && (
            <>
              <Typography
                variant={isMobileOrTablet ? "body2" : "body1"}
                color={theme?.palette?.screenBackground?.textColor || theme?.palette?.primary.main}
                align="center"
                mt={3}
                mx={isMobileOrTablet ? 2 : 20}
                fontWeight={500}
              >
                Tu solicitud sigue activa en nuestro Marketplace. Aún no ha sido seleccionada por ninguna de las
                instituciones financieras aliadas.
              </Typography>

              <Typography
                variant={isMobileOrTablet ? "body2" : "body1"}
                color={theme?.palette?.screenBackground?.textColor || theme?.palette?.primary.main}
                align="center"
                mt={3}
                mx={isMobileOrTablet ? 2 : 20}
                fontWeight={500}
              >
                Recuerda que las financieras revisan solicitudes de forma continua, así que aún puede haber
                oportunidades.
              </Typography>

              <Typography
                variant={isMobileOrTablet ? "body2" : "body1"}
                color={theme?.palette?.screenBackground?.textColor || theme?.palette?.primary.main}
                align="center"
                mt={3}
                fontWeight={700}
              >
                ¡No te desanimes!
              </Typography>
            </>
          )}

          {type === "rechazado" && (
            <>
              <Typography
                variant={isMobileOrTablet ? "body2" : "body1"}
                color={theme?.palette?.screenBackground?.textColor || theme?.palette?.primary.main}
                align="center"
                mt={3}
                mx={isMobileOrTablet ? 2 : 20}
                fontWeight={500}
              >
                En esta ocasión, tu solicitud no recibió propuestas dentro del tiempo establecido.
                <br />
                <br />
                Sabemos que puede ser frustrante, pero tu camino al financiamiento no termina aquí.
              </Typography>

              <Typography
                variant={isMobileOrTablet ? "body2" : "body1"}
                color={theme?.palette?.screenBackground?.textColor || theme?.palette?.primary.main}
                align="center"
                mt={3}
                fontWeight={700}
                mx={isMobileOrTablet ? 2 : 20}
                mb={4}
              >
                Vuelve a intentarlo en 3 meses con tu información actualizada.
                <br />
                Estaremos aquí para ayudarte a lograrlo.
              </Typography>
            </>
          )}

          <Box display="flex" justifyContent="center" mt={4} mb={4}>
            <IconRejected width={isMobileOrTablet ? "110" : "170"} fill={theme?.palette?.screenBackground?.textColor || theme?.palette?.primary.main} />
          </Box>

          {type === "sin_oferta" && (
            <>
              <Typography
                variant={isMobileOrTablet ? "body2" : "body1"}
                color={theme?.palette?.screenBackground?.textColor || theme?.palette?.primary.main}
                align="center"
                mt={3}
              >
                Para cualquier duda o aclaración contáctanos a: <br />
                Tel:
                <Link
                  href="tel:+525591044964"
                  color={theme?.palette?.screenBackground?.textColor || theme?.palette?.primary.main}
                >
                  55 9104 4964
                </Link>
              </Typography>
              <Typography
                variant={isMobileOrTablet ? "body2" : "body1"}
                color={theme?.palette?.screenBackground?.textColor || theme?.palette?.primary.main}
                align="center"
                fontWeight={300}
                mt={1}
              >
                Correo:
                <Link
                  href="mailto:contacto@lendia.mx"
                  color={theme?.palette?.screenBackground?.textColor || theme?.palette?.primary.main}
                >
                  contacto@lendia.mx
                </Link>
              </Typography>
            </>
          )}

          <Box display="flex" justifyContent="center" mt={3}>
            <Button variant="default" onClick={handleClick} sx={{ width: "130px" }}>
              Salir
            </Button>
          </Box>
        </Box>
      </Grid>

      {!isMobileOrTablet && (
        <Grid item xs={12} md={4}>
          <CustomRightImage />
        </Grid>
      )}
    </Grid>
  );
};

export default SinOferta;
